<template>
  <div>
    <BaseFrame  :submitLoading='downLoadLoading'>

      <div slot="content">
        <lk-card title="申请单信息">
          <lk-form :label-width="160"  :model='info.ep' ref="form">
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-row :gutter='16'>
                  <lk-form-item label='门店名称:'>
                    <!-- <lk-input v-if=" canUpdate" v-model="info.ep.patientName"></lk-input> -->
                    <span >{{info.ep.storeName}}</span>
                  </lk-form-item>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-form-item label='对接方:' prop='patientPhone'>
                    <!-- <lk-input v-if="canUpdate" v-model="info.ep.patientPhone"></lk-input> -->
                    <span >{{info.ep.source}}</span>
                  </lk-form-item>
                </lk-row>

                  <lk-row :gutter='16'>
                    <lk-form-item label='援助申请单号:'>

                    <span >{{info.ep.code|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='患者姓名:'>

                    <span >{{info.ep.patientName|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='联系方式:'>

                    <span >{{info.ep.patientPhone|defaultStr}}</span>
                    </lk-form-item>
                     </lk-row>
                  <lk-row :gutter='16'>
                    <lk-form-item label='状态:'>

                    <span >{{info.orderStatusName|defaultStr}}</span>
                    </lk-form-item>
                  </lk-row>
                <lk-row :gutter='16'>
                  <lk-table :columns='columns' :data=info.epDetailVoList border></lk-table>
                </lk-row>
                <img :src="src" alt="">
              </lk-col>
              <lk-col span='11' offset='1' >

          <lk-row :gutter='16'>
            <lk-form-item label='患者身份证图片:'>

              <Uploader v-model='info.idCardFaceUrl'></Uploader>
              <Uploader v-model='info.idCardBackUrl'></Uploader>
              <!-- <span>{{info.ep.patientPhone|defaultStr}}</span> -->
            </lk-form-item>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-form-item label='协议:'>

<Uploader v-model='info.protocolUrl'></Uploader>
              <!-- <span>{{info.ep.patientPhone|defaultStr}}</span> -->
            </lk-form-item>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-form-item label='处方药品订单图片:'>
<Uploader v-model='info.ep.picUrl'></Uploader>
              <!-- <span>{{info.ep.patientPhone|defaultStr}}</span> -->
            </lk-form-item>
          </lk-row>


                <!-- <div class="prescriptionContainer" >
                  <div class="printContainer" id="pic">
                    <img ref="pic" class='stamp' :src="info.ep.picUrl" alt="" v-if="info.ep.picUrl">

                  </div>
                </div>
                <div class="btnContainer">
                  <lk-button @click="downLoadPDF" type='primary' :loading='downLoadLoading'>下载
                  </lk-button>
                </div> -->
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import Uploader from '../../components/Uploader.vue';
import aid from '../../services/aid';
import utils from '../../libs/utils';

export default {
  name: 'aidApplyInfo',
  components: {
    BaseFrame, Uploader,
  },
  computed: {
    // isPrescrption() {
    //   // if (this.$route.name.include('prescription')) {
    //   //   return false;
    //   // }
    //   return this.$route.name && this.$route.name.includes('prescription');
    // },

  },
  data() {
    return {


      able: false,
      src: '',
      downLoadLoading: false,
      frozenStatusStringList: {
        1: '冻结',
        2: '解冻',
      },
      info: {
        ep: {},
        epDetailList: [],
        epProceedsList: [{
          proceedsTypeName: null,
          amount: null,
        }],
      },
      columns: [{
        title: '序号',
        type: 'index',
      },
      {
        title: '商品编码',
        key: 'serialCode',
      },
      {
        title: '商品通用名',
        key: 'approvedDrugNames',
      },
      {
        title: '规格',
        key: 'spec',
      },
      {
        title: '数量',
        key: 'epDetailNum',
      },
      ],
    };
  },
  methods: {
    // submit() {
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       const temp = {

    //         id: this.info.ep.id,
    //         remark: this.info.ep.remark,
    //         frozenStatus: this.info.frozenStatus,
    //         patientName: this.info.ep.patientName,
    //         patientPhone: this.info.ep.patientPhone,
    //         consigneeName: this.info.ep.consigneeName,
    //         consigneePhone: this.info.ep.consigneePhone,
    //         consigneeAddress: this.info.ep.consigneeAddress,
    //         onlineOrderCode: this.info.ep.onlineOrderCode,

    //       };
    //       sale.prescriptionEdit(temp).then((res) => {
    //         if (res.data.status === 200) {
    //           this.$Message.success('提交成功');
    //           this.$router.push({
    //             name: 'prescriptionList',
    //           });
    //         } else {
    //           this.$Message.error(res.data.error);
    //         }
    //       }).catch((err) => {
    //         utils.handleError(err);
    //       });
    //     }
    //   });
    // },
    // getBase64Image() {
    //   // const img = this.$refs.pic;
    //   // const el=img
    //   const img = new Image();
    //   img.setAttribute('crossOrigin', 'anonymous');
    //   img.src = this.$refs.pic.url;

    //   const canvas = document.createElement('canvas');
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   const ctx = canvas.getContext('2d');
    //   ctx.drawImage(img, 0, 0, img.width, img.height);


    //   const dataURL = canvas.toDataURL('image/png', 1);
    //   return dataURL;

    //   // return dataURL.replace("data:image/png;base64,", "");
    // },
    // downLoadPDF() {
    //   const el = this.$refs.pic;
    //   window.open(el.src);
    // },
    getData(epId) {
      aid.getAidApplyDetail({
        epId,
      }).then((res) => {
        if (res.data.status === 200) {
          this.info = res.data.data;
          // this.info.ep.picUrl = decodeURIComponent(this.info.ep.picUrl);
          this.info.epDetailVoList = this.info.epDetailVoList.map((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            return result;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    // this.$route.name.includes('Edit') && (this.able = true);

    this.getData(this.$route.params.id);
  },
};

</script>
<style lang="less" scoped>
  .btnContainer {
    text-align: center
  }

  .printContainer {
    overflow: scroll;
    padding: 5px 0;
    border: 1px solid #eee;

    .stamp {
      width: 100%
    }
  }

</style>
